/**
 * FichaPanel — columna derecha en pantalla ancha (2026-10-01).
 *
 * La ficha del producto sugerido queda fija mientras sigue la conversación: dosis,
 * stock en la sucursal, alternativas, complementos y fuente. Tocar un producto
 * anterior en la conversación la vuelve a traer.
 */
import type { ReactNode } from 'react'
import type { Message } from '../store/chat'
import { ProductCard } from './ProductCard'
import { OpcionesProducto } from './OpcionesProducto'
import { DerivacionBanner } from './DerivacionBanner'

interface Props {
  mensaje: Message | null
  device_id?: string
  onPick: (text: string) => void
  ocupado: boolean
  /** 21-oct: las acciones van dentro de la tarjeta si la ficha es la de la última respuesta. */
  acciones?: ReactNode
}

export function FichaPanel({ mensaje, device_id, onPick, ocupado, acciones }: Props) {
  const card = mensaje?.card
  return (
    <aside className="panel-ficha" aria-label="Ficha del producto sugerido">
      <h2 className="panel-titulo">Ficha del producto</h2>
      {!card ? (
        <div className="ficha-vacia">
          <p className="ficha-vacia-titulo">Todavía no hay un producto sugerido</p>
          <p>Cuando el asistente sugiera algo, acá queda la ficha completa:</p>
          <ul>
            <li>dosis y días, con la fuente clínica</li>
            <li>unidades y precio en tu sucursal</li>
            <li>equivalentes y otras marcas con stock</li>
            <li>complementos y cuándo derivar al médico</li>
          </ul>
        </div>
      ) : (
        <div className="ficha-contenido">
          {mensaje?.derivacion && mensaje.derivacion.length > 0 && (
            <DerivacionBanner derivacion={mensaje.derivacion} />
          )}
          <ProductCard card={card} trace_id={mensaje?.trace_id ?? null} consulta_id={mensaje?.consulta_id ?? null}
            device_id={device_id} acciones={acciones} onSumar={acciones && !ocupado ? onPick : undefined} />
          <OpcionesProducto card={card} ocupado={ocupado} onPick={onPick} />
        </div>
      )}
    </aside>
  )
}
